export default __webpack_public_path__ + "static/media/p9.696f603e.jpg";